import Vue from "vue";
import "./plugins/vuetify";
import App from "./App.vue";
import VueRouter from "vue-router";

import Amplify, * as AmplifyModules from "aws-amplify";
import { AmplifyPlugin, AmplifyEventBus } from "aws-amplify-vue";

Vue.use(AmplifyPlugin, AmplifyModules);

// Styles
import "./assets/scss/nswa-hydro.scss";

// Plugins
import VueChartist from "vue-chartist";
Vue.use(VueChartist);

// Config
import config from "./config";
import aws_exports from "@/aws-exports";
Amplify.configure(aws_exports);

// router setup
import routes from "./router/routes";
Vue.use(VueRouter);
const router = new VueRouter({
  routes, // short for routes: routes
  linkExactActiveClass: "nav-item active",
});

Vue.config.productionTip = false;

// global library setup
Object.defineProperty(Vue.prototype, "$Config", {
  get() {
    return this.$root.Config;
  },
});
Object.defineProperty(Vue.prototype, "$API", {
  get() {
    return this.$root.API;
  },
});
Object.defineProperty(Vue.prototype, "$Auth", {
  get() {
    return this.$root.Auth;
  },
});
Object.defineProperty(Vue.prototype, "$signOut", {
  get() {
    return this.$root.signOut;
  },
});
Object.defineProperty(Vue.prototype, "$authenticated", {
  get() {
    return this.$root.authenticated;
  },
});
Object.defineProperty(Vue.prototype, "$user", {
  get() {
    return this.$root.user;
  },
});

new Vue({
  render: (h) => h(App),
  router,

  beforeCreate() {
    AmplifyEventBus.$on("authState", (info) => {
      if (info === "signedIn") {
        this.getUser();
      }
    });
  },

  beforeMount() {
    this.getUser();
  },

  data() {
    return {
      Config: config,
      API: AmplifyModules.API,
      Auth: AmplifyModules.Auth,
      user: null,
      authenticated: false,
    };
  },

  methods: {
    getUser() {
      AmplifyModules.Auth.currentAuthenticatedUser()
        .then((user) => {
          this.signIn(user);
        })
        .catch(() => {
          this.signOut();
        });
    },

    signIn(user) {
      this.user = user;
      this.authenticated = true;
    },

    signOut() {
      this.$Auth
        .signOut()
        .then(() => {
          this.user = null;
          this.authenticated = false;
        })
        .catch(() => {});
    },
  },
}).$mount("#app");
